import { render } from "./ExternalMenuItem.vue?vue&type=template&id=e20e0736&scoped=true"
import script from "./ExternalMenuItem.vue?vue&type=script&lang=js"
export * from "./ExternalMenuItem.vue?vue&type=script&lang=js"

import "./ExternalMenuItem.vue?vue&type=style&index=0&id=e20e0736&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e20e0736"]])

export default __exports__